import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "../pages/Home/Home";
import TestPage from "../pages/TestPage/TestPage";
import StockDetail from "../pages/StockDetail/StockDetail";
import Overview from "../pages/StockDetail/Overview";
import CeoMessage from "../pages/StockDetail/CeoMessage";
import StockPrices from "../components/StockPrices/StockPrices";
import MarketSketchDetail from "../components/MarketSketch/MarketSketchDetail";
import MarketSketch from "../components/MarketSketch/MarketSketch";
import Register from "../pages/Register/Register";
import Login from "../pages/Login/Login";
import AdminRoutes from "./AdminRoutes";
import TeaserViewer from "../pages/StockDetail/TeaserViewer";
import VideoClip from "../pages/StockDetail/VideoClip";
import News from "../pages/StockDetail/News";

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/register" element={<Register />} />
      <Route path="/login" element={<Login />} />
      <Route path="/prices" element={<StockPrices />} />
      <Route path="/marketSketch" element={<MarketSketch />} />
      <Route path="/marketSketch/:newsId" element={<MarketSketchDetail />} />
      <Route path="/stocks/:id" element={<StockDetail />}>
        <Route path="overview" element={<Overview />} />
        <Route path="ceo" element={<CeoMessage />} />
        <Route path="teaser" element={<TeaserViewer />} />
        <Route path="news" element={<News />} />
        <Route path="video" element={<VideoClip />} />
        <Route path="chat" element={<h2>Chat</h2>} />
      </Route>
      <Route path="/admin/*" element={<AdminRoutes />} /> {/* 관리자 라우트 */}
      <Route path="/test" element={<TestPage />} />
    </Routes>
  );
};

export default AppRoutes;
